var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('a-carousel',{attrs:{"autoplay":""}},[_c('div',{staticClass:"carousel"},[_c('img',{attrs:{"src":require("../../assets/img/carousel1.png"),"alt":""}})]),_c('div',{staticClass:"carousel"},[_c('img',{attrs:{"src":require("@/assets/img/carousel2.png"),"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }